/* eslint-disable react/jsx-key */
import React, { PropsWithChildren } from 'react';

// Components
import ComparisonMatrixItem from '../options/ComparisonMatrixItem';
import ComparisonMatrixTitle from '../ComparisonMatrixTitle';
import OfferOptionButton from '../../../../../../components/offers/offer-options/OfferOptionButton';
import { LouiseQuote } from '../../../../../../../../../types/Quotes';
import { useTranslation } from 'react-i18next';
import { Text, Wrap } from '@wegroup/design-system';

interface Props {
  quotes: LouiseQuote[];
}

const ComparisonMatrixOverview: React.FC<React.PropsWithChildren<Props>> = ({
  quotes,
}) => {
  const { t } = useTranslation();

  const options = quotes.map((quote) => (
    <IconWrapper>
      {quote.guarantee_content?.map(({ key, description, name }) => (
        <OfferOptionButton
          type={key}
          active={quote.selected_guarantees.includes(key)}
          disabled
          isSmall
          insuranceType={quote.info.insurance_type}
          description={description}
        >
          {name}
        </OfferOptionButton>
      ))}
    </IconWrapper>
  ));

  const bestOfferindex = quotes.findIndex(({ bestOffer }) => bestOffer);

  return (
    <>
      <ComparisonMatrixTitle quotes={quotes} withBackground>
        {t('Overview')}
      </ComparisonMatrixTitle>
      <ComparisonMatrixItem
        values={{ nodes: options }}
        bestOfferIndex={bestOfferindex}
        withBackground
        last
      >
        <Text>{t('Options')}</Text>
      </ComparisonMatrixItem>
    </>
  );
};

const IconWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return <Wrap spacing="1">{children}</Wrap>;
};

export default ComparisonMatrixOverview;
